export const LAB_URL=`${process.env.REACT_APP_BASE_LAB_URL}`;
export const IAM_URL=`${process.env.REACT_APP_BASE_IAM_URL}`;
export const FORTIFICATION_URL=`${process.env.REACT_APP_BASE_FORTIFICATION_URL}`;
export const IMMUDB_URL=`${process.env.REACT_APP_BASE_IMMUDB_URL}`;
export const AUTH_URL=`${process.env.REACT_APP_AUTH_SERVER_URL}`;
export const LAB_URL_RICE=`${process.env.REACT_APP_BASE_LAB_URL_RICE}`;
export const IAM_URL_RICE=`${process.env.REACT_APP_BASE_IAM_URL_RICE}`;
export const FORTIFICATION_URL_RICE=`${process.env.REACT_APP_BASE_FORTIFICATION_URL_RICE}`;
export const IMMUDB_URL_RICE=`${process.env.REACT_APP_BASE_IMMUDB_URL_RICE}`;